export const faqData = [
  {
    title: "What services do the NHWM offer?",
    content: {
      p1: "✔️ Health Awareness Programs – Free sessions on preventing and managing lifestyle diseases like diabetes, heart disease, and obesity.",
      p2: "✔️ Nutritional Assessments – Personalized evaluations to identify deficiencies and health risks, with expert dietary guidance.",
      p3: "✔️ Personalized Counselling – One-on-one consultations, available in free and paid options, for customized health solutions.",
      p4: "✔️ Coaching & Training – Certification programs for those interested in health coaching and wellness education.",
      p5: "✔️ Assurance Plans – Affordable health plans with free supplements, routine check-ups, and continuous health support.",
      fot: "NHWM is dedicated to helping individuals achieve long-term health and wellness. Would you like more details?",
      linkText: "View Our Services",
      link: "#ourservices",
    },
  },
  {
    title: "How can I schedule an appointment with NHWM?",
    content: {
      p1: "✔️ Call or WhatsApp – Contact our helpline to speak with a representative and book your session.",
      p2: "✔️ Visit Our Website – Register online for health assessments, counselling, or wellness programs at your convenience.",
      p3: "✔️ Attend a Local Event – Join one of our free health awareness sessions and schedule a consultation on-site.",
      p4: "✔️ Membership Registration – Enroll as a Health Seeker or NHWM Member to access exclusive wellness services and personalized counselling.",
      p5: "",
      fot: "For exact details, visit our official website or contact our support team today! ",
      linkText: "Go to Contact Page",
      link: "/contact",
    },
  },
  {
    title: "Can I Consult with a Specialist Online?",
    content: {
      p1: "Yes! NHWM offers online consultations with healthcare and wellness specialists, making it easy to get expert guidance from anywhere. NHWM also offers online consultations with Doctors in emergency. ",
      p2: "✔️ Virtual Appointments – Schedule one-on-one video or phone consultations with qualified professionals.",
      p3: "✔️ Online Health Assessments – Get personalized health evaluations and expert recommendations remotely.",
      p4: "✔️ Live Counselling & Coaching – Receive tailored advice on nutrition, disease prevention, and lifestyle improvements.",
      p5: "✔️ Flexible Plans – Choose from free sessions, paid consultations, or  membership-based wellness programs.",
      fot: "To book an online consultation, visit our website or contact our support team today!",
      linkText: "Go to Contact Page",
      link: "/contact",
    },
  },
  {
    title: "How health checkup works with chornic disease?",
    content: {
      p1: "For individuals with chronic diseases like diabetes, high blood pressure, heart disease, and arthritis, regular health check-ups are essential for monitoring, managing, and preventing complications. Here’s how they work:",
      p2: "✔️ Comprehensive Health Assessment – Doctors evaluate medical history, symptoms, and lifestyle factors to assess overall health.",
      p3: "✔️ Regular Diagnostic Tests – Blood tests, cholesterol levels, kidney function, ECG, and other screenings help track disease progression and detect early warning signs.",
      p4: "✔️ Personalized Treatment & Lifestyle Guidance – Based on test results, specialists provide customized medication plans, dietary recommendations, and exercise routines to help manage the condition.",
      p5: "✔️ Ongoing Monitoring & Adjustments – Continuous check-ups allow healthcare professionals to adjust treatments, prevent complications, and improve long-term well-being.",
      fot: "Routine health check-ups are crucial for controlling chronic diseases and enhancing quality of life. Need help scheduling one?",
      linkText: "Go to Contact Page",
      link: "/contact",
    },
  },
  {
    title: "How does the Free Health Session Work?",
    content: {
      p1: "At NHWM, your health and well-being are our priority. Our Free Health Sessions are designed to educate, guide, and empower you with the right knowledge and tools to make informed health decisions. Here’s what to expect:",
      p2: "✔️ Expert-Led Awareness Sessions – Learn about disease prevention, nutrition, and wellness strategies from experienced healthcare professionals.",
      p3: "✔️ Interactive Q&A – Get your health-related questions answered by specialists to help you take control of your well-being.",
      p4: "✔️ Health Assessments – Receive basic health check-ups and nutritional evaluations to understand your current health status.",
      p5: "✔️ Personalized Guidance – Get recommendations on lifestyle changes, diet improvements, and wellness plans tailored to your needs.",
      fot: "Take advantage of this free opportunity to invest in your health! Join our next session and start your journey to a healthier life.",
      linkText: "Book a Free Session Now",
      link: "/register",
    },
  },
];